import { CaseDocument } from "@/cms/models";
import { formatBytes } from "@/utils/helper";
import React from "react";
import DocumentIcon from "./DocumentIcon";

const DocumentCard: React.FC<{
  document: CaseDocument;
  textColor?: string;
  onClick: () => void;
}> = ({ document, textColor, onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className="bg-white aspect-square border flex flex-col cursor-pointer items-center homepage-text-sm homepage-card-rounded"
    >
      <div
        style={
          {
            "--text-color": textColor ? textColor : "inherit",
          } as React.CSSProperties
        }
        className="flex flex-col items-center justify-center flex-1 gap-4 p-4 text-[var(--text-color)]"
      >
        <DocumentIcon document={document} className="size-10" />
        <div className="overflow-hidden w-full text-center">
          <span className={`test-sm truncate text-wrap`}>
            {document.displayName}
          </span>
        </div>
      </div>
      <div className="flex w-full flex-col lg:flex-row justify-between border-t divide-y lg:divide-y-0 lg:divide-x text-[#a7a9ac]">
        <div className="p-3 flex-1">{formatBytes(document.size)}</div>
      </div>
    </button>
  );
};

export default DocumentCard;
